import $ from 'jquery'
const queryParams = (params) => {
    return $.param(params)
}
export default queryParams
